/* eslint-disable no-magic-numbers */
import React from 'react';
import { Select, Option, SimpleSelectProps } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';

import { NonFinancialDriverTreeNode } from '../../types';
import styles from './add-to-group-menu.scss';

interface AddToGroupMenuProps extends Omit<SimpleSelectProps, 'children'> {
  groups?: NonFinancialDriverTreeNode[];
}

export const NO_GROUP_VALUE = 'no-group-option';

export const AddToGroupMenu = ({ groups = [], ...props }: AddToGroupMenuProps) => {
  const intl = useIntl();

  return (
    <Select
      data-testid="AddToGroupMenu"
      autoComplete="off"
      label={intl.formatMessage({
        id: 'predict.add_to_group',
        defaultMessage: 'Add to group'
      })}
      size="large"
      mb="20px"
      placeholder={intl.formatMessage({ id: 'common.predict.please_select', defaultMessage: 'Please select...' })}
      {...props}
    >
      <Option
        value={NO_GROUP_VALUE}
        className={styles.noGroupCarbon}
        text={intl.formatMessage({ id: 'predict.no_group', defaultMessage: 'No group' })}
      />
      {groups.map(group => (
        <Option key={group.id} value={group.id} text={group.name}>
          <span
            style={{
              paddingLeft: `${16 + (group.depth - 1) * 12}px`
            }}
          >
            {group.name}
          </span>
        </Option>
      ))}
    </Select>
  );
};
